interface Description {
  title: string;
  title_2: string;
  title_3: string;
  content: string[];
}

interface Story {
  title: string;
  content: string[];
}

interface Schedule {
  content: string[];
}

interface Ticket {
  content: string[];
  webMember: string[];
}

interface Performer {
  content: string[];
}

interface Cautions {
  content: string[];
}

interface Credits {
  content: string[];
}

interface Texts {
  TOPGUN_TITLE: string;
  TOPGUN_TITLE_2: string;
  CONTENT: string;
  MAIN_CONTENT_2: string;
  MAIN_CONTENT_3: string;
  MAIN_CONTENT_4: string;
  MAIN_CONTENT_5: string;
  MAIN_CONTENT_6: string;
  MAIN_CONTENT_7: string;
  MAIN_CONTENT_8: string;
  MAIN_CONTENT_9: string;
  MAIN_CONTENT_10: string;
  MAIN_CONTENT_11: string;
  MAIN_CONTENT_12: string;
  Description: Description;
  Story: Story;
  Schedule: Schedule;
  Ticket: Ticket;
  Performer: Performer;
  Cautions: Cautions;
  Credits: Credits;
}

export const TEXTS: Texts = {
  TOPGUN_TITLE: "歴史的大ヒット『トップガン マーヴェリック』",
  TOPGUN_TITLE_2: "全世代待望のシネマコンサートがついに日本上陸！",
  CONTENT:
    "日本では2022年5月に公開され、興行収入が驚異の137億円を突破した映画\n『トップガン マーヴェリック』",
  MAIN_CONTENT_2: "2022年の国内映画興行収入ランキングで洋画部門第1位を獲得し、",
  MAIN_CONTENT_3:
    "全世界ではトム・クルーズの\u200Bキャリア最高額と\u200Bなる10億ドル超えの\u200B大ヒットを記録！",
  MAIN_CONTENT_4: "まさに映画史に名を刻む伝説の作品となった。",
  MAIN_CONTENT_5:
    "そんな大ヒット作品をオーケストラの極上の生演奏とともに上映し、",
  MAIN_CONTENT_6:
    "イギリスやドイツをはじめ全世界10都市以上で大好評を博している",
  MAIN_CONTENT_7:
    "「トップガン マーヴェリック シネマコンサート」が遂に日本で開催決定！",
  MAIN_CONTENT_8: "日本中に熱狂を巻き起こした『トップガン マーヴェリック』を",
  MAIN_CONTENT_9:
    "＜大スクリーンでの映画全編上映 × オーケストラによる大迫力の生演奏＞でお届けする、",
  MAIN_CONTENT_10: "全世代が楽しめる最高のエンターテインメント・コンサート！",
  MAIN_CONTENT_11: "この夏は、「トップガン マーヴェリック シネマコンサート」で",
  MAIN_CONTENT_12:
    "熱い感動と興奮に満ちた忘れられないひとときをお楽しみください！",
  Description: {
    title: "「シネオケ",
    title_2: "®",
    title_3: "とは？」",
    content: [
      "“大スクリーンでの映画上映 × オーケストラ生演奏による音楽”でお届けする\n新たなスタイルのコンサート「シネオケ®」。",
      "演奏を聴くだけではなく、映画そのものを大スクリーンで楽しめるので、\n大迫力の「映像」とオーケストラの極上の演奏による「音楽」の両方を卓越した臨場感で体験でき、\n作品の世界観に没入できます。",
      "「シネオケ®」は、株式会社キョードー東京の商標です。",
    ],
  },
  Story: {
    title: "上映作品",
    content: [
      "トップガン マーヴェリック",
      "(2022年公開作品）",
      "英語上映・日本語字幕 / 上映時間：約2時間15分（休憩除く）",
      "監督 : ジョセフ・コジンスキー",
      "音楽 : ローン・バルフ、ハロルド・フォルターメイヤー、\nレディー・ガガ、ハンス・ジマー",
      "アメリカ海軍のエリートパイロット養成学校トップガンに、",
      "伝説のパイロット、マーヴェリックが教官として帰ってきた。\n空の厳しさと美しさを誰よりも知る彼は、",
      "守ることの難しさと戦うことの厳しさを教えるが、訓練生たちはそんな彼の型破りな指導に戸惑い反発する。",
      "その中には、かつてマーヴェリックとの訓練飛行中に命を落とした相棒グースの息子ルースターの姿もあった。",
      "ルースターはマーヴェリックを恨み、彼と対峙するが……。",
      "ABOUT THE MOVIE",
    ],
  },
  Schedule: {
    content: [
      "2025年",
      "8",
      "月",
      "14",
      "日",
      "（木）",
      "昼公演・開場12:30 開演13:30",
      "夜公演・開場17:30 開演18:30",
      "※英語上映・日本語字幕",
      "会場",
      "東京国際フォーラム ホールA",
      "〒100-0005 東京都千代田区丸の内3丁目5番1号",
      "（外部リンク）",
    ],
  },
  Ticket: {
    content: [
      "料金",
      "S席 9,900 円",
      "A席 8,800 円",
      "B席 4,900 円",
      "全席指定席・税込",
      "CN プレイガイド",
      "ご購入はこちらから",
      "全席指定席・税込",
      "お問い合わせ",
      "キョードー東京 0570-550-799",
      "（平日11時～18時 / 土日祝 10時～18時）",
      "先行販売",
      "WOWOW WEB会員先行",
      "▶お申込みにはWOWOWのWEBアカウント（登録無料）が必要となります。",
      "受付期間：2025年4月17日(木) 18:00 〜 2025年5月6日(火祝) 23:59",
      "お申込み",
      "チケットぴあ最速先行",
      "受付期間：2025年4月26日(土) 10:00 〜 2025年5月13日(火) 23:59",
      "COMING SOON",
      "チケットぴあ二次先行",
      "受付期間：2025年5月17日(土) 10:00 〜 2025年6月5日(木) 23:59",
      "COMING SOON",
      "一般販売",
      "一般販売",
      "2025年6月14日(土) 10:00〜",
      "COMING SOON",
      "（抽選）",
      "（先着）",
      "TBSラジオ先行",
      "受付終了",
    ],
    webMember: [
      "■WOWOW WEB会員について",
      "WOWOW WEBアカウントとは、WOWOWのWEBサービスをご利用いただけるアカウント(無料)のことです。様々なサービスをご用意しておりますが、各種WEBサービスのご利用にはWEBアカウント登録が必要です。ご登録いただくことでWEBアカウントでログインいただけます。尚、WOWOWのご視聴ができるアカウントではございませんので、既にご契約済みの方でWEBアカウントをお持ちでない方は、ご登録が新たに必要となります。",
      "WEBアカウントの登録は",
      "こちら",
      "■WEBアカウント登録方法",
      "WEBアカウント新規登録（無料）は",
      "こちら",
      "・メールアドレス",
      "・パスワード",
      "・氏名",
      "・電話番号",
      "・生年月日",
      "・性別",
      "をご入力いただき、アカウント登録が完了となります。",
      "詳しくは",
      "こちら",
      "■お問い合わせ",
      "ご不明点ございましたら、",
      "WOWOWカスタマーセンター",
      "へお気軽にお問い合わせください。",
    ],
  },
  Performer: {
    content: [
      "指揮",
      "辻 博之",
      "Hiroyuki Tsuji",
      `東京藝術大学音楽学部声楽科を卒業し、2017年にオーケストラ・アンサンブル・金沢定期演奏会に指揮者デビュー。\nその後も、九州交響楽団、読売日本交響楽団、兵庫芸術文化センター管弦楽団、東京フィルハーモニー交響楽団、東京21世紀管弦楽団、大阪フィルハーモニー交響楽団、札幌交響楽団、新日本フィルハーモニー交響楽団、京都市交響楽団等と共演。`,
      `　2021年には東京芸術劇場シアターオペラ《夕鶴》（團伊玖磨）を指揮し、『音楽現代』誌に「活躍を期待する指揮者」として取り上げられる。また、新国立劇場オペラ研修所公演《悩める劇場支配人》はイギリス『オペラ』誌上で「優雅かつ的確な細やかさで、チマローザの音楽に脈々と流れる歓喜を引き出した」と評され、オペラ指揮者としての頭角を表している。`,
      `　舞台作品への劇音楽の作曲や、クラシック以外のアーティストとの共演、ディズニー・オン・クラシック等、垣根の無い音楽活動も積極的に行う他、幼児や子供との音楽活動に力を注ぎ、千葉県文化振興財団との幼稚園出張コンサートは10年で100公演以上を数える。楽しいお話を交えた家族で楽しむコンサート、赤ちゃんと一緒に参加できる合唱団等、〈音楽を未来に繋げる〉活動も積極的に行なっている。`,
      "演奏",
      "WOWOW シネマオーケストラ",
      "©",
      "濱津和貴",
    ],
  },
  Cautions: {
    content: [
      "注意事項",
      "※主催者の同意なく有償で譲渡することは禁止します。",
      "※各席種ごとに、数に限りがございます。予定枚数に達し次第終了となりますので、あらかじめご了承ください。",
      "※お一人様1公演につき4枚までご購入いただけます。",
      "※5歳未満のお子様はご入場できません。",
      "※車いすをご利用のお客様はS席をご購入いただき、",
      "　事前にキョードー東京　0570-550-799（平日11時～18時 / 土日祝 10時～18時）まで来場の旨をご連絡ください。",
      "※英語上映・日本語字幕となります。",
      "※万が一出演者が変更になった場合でも、チケットの払い戻しには対応いたしかねます。",
      "※キャストの登壇はございません。",
    ],
  },
  Credits: {
    content: [
      "“A Royal Albert Hall production” and “With thanks to esk film”　\nSymphonic Cinema Presents",
      "“Original Music Score by　\nLorne Balfe, Harold Faltermeyer, Lady Gaga and Hans Zimmer.”",
      "主催 : WOWOW / キョードー東京 / 朝日新聞社 / 松竹音楽出版 / TBSラジオ",
      "企画・制作",
    ],
  },
};
